var _rect, _rect2, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResultUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 176,
    fill: "none",
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 176,
    fill: "#2B2870",
    rx: 88
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23_74",
    width: 176,
    height: 176,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 176,
    fill: "#fff",
    rx: 88
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_23_74",
    width: 87,
    height: 101,
    x: 44,
    y: 38,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M44 38H130.643V138.271H44V38Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_23_74)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7AB2CC",
    fillRule: "evenodd",
    d: "M77.5362 39.1381C58.4793 42.9735 41.9532 62.3502 44.2064 88.1457C46.4596 113.942 66.8039 145.375 112.499 136.844C131.479 132.255 129.712 111.209 128.815 100.832C127.92 90.4556 135.793 72.2781 124.421 54.8417C113.051 37.4062 90.9577 36.4366 77.5362 39.1381",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A2BD",
    fillRule: "evenodd",
    d: "M59.1246 82.2644C49.1984 87.2046 49.2841 108.072 61.6592 114.851C74.0354 121.63 91.9908 117.758 94.9429 112.368C99.3944 104.236 88.978 89.3039 78.7987 83.9797C70.1816 79.4734 64.151 79.762 59.1246 82.2644",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M65.3389 88.8203C57.9462 92.5416 57.9383 106.591 67.1555 111.696C76.3737 116.802 88.2511 114.035 90.3785 109.938C92.8671 105.147 87.5742 94.1228 79.992 90.1124C73.5743 86.7177 69.0826 86.9365 65.3389 88.8203",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A2BD",
    fillRule: "evenodd",
    d: "M129.126 100.335C128.514 93.5034 131.87 83.2631 130.781 72.0925C128.614 68.5296 124.877 67.1099 119.002 70.0559C112.731 73.2008 101.72 86.0729 107.746 102.081C109.95 107.937 121.577 109.936 128.014 103.383C128.441 102.948 128.853 102.386 129.248 101.73C129.207 101.249 129.166 100.779 129.126 100.335",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M116.957 75.6586C112.538 78.0156 106.149 87.0663 110.396 99.0627C111.95 103.451 118.772 105.544 123.308 100.633C128.006 95.5481 130.343 68.5208 116.957 75.6586",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M120.121 85.469C118.331 85.6293 116.833 87.65 115.852 89.0586C114.548 90.9309 113.362 93.1099 114.39 95.4C114.704 96.1023 115.547 96.6193 116.291 96.4249C118.615 95.8148 119.471 93.697 120.168 91.4579C120.689 89.7829 121.454 87.4496 120.652 85.7556C120.547 85.5332 120.344 85.449 120.121 85.469",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M72.0478 102.035C72.8205 103.461 75.1518 104.191 76.8045 104.713C79.0568 105.424 81.2686 105.979 83.3436 104.699C84.0029 104.291 84.168 103.446 83.8277 102.853C82.7299 100.937 80.2984 100.609 77.9418 100.502C76.1574 100.422 73.5273 100.376 72.1825 101.52C72.0154 101.662 71.9455 101.846 72.0478 102.035",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A2BD",
    fillRule: "evenodd",
    d: "M112.987 107.934C113.395 106.784 103.969 91.2996 100.753 92.5365C98.1208 93.5512 96.0661 113.225 97.4385 113.466",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A2BD",
    fillRule: "evenodd",
    d: "M106.019 114.308C99.5427 116.264 88.7146 119.53 91.4278 127.234C93.7641 133.865 105.998 131.336 110.424 128.82C114.416 126.552 124.025 123.751 122.911 115.719C121.796 107.688 109.316 113.313 106.019 114.308",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M105.734 115.598C100.674 117.065 92.215 119.515 94.334 125.292C96.1593 130.265 105.718 128.369 109.175 126.481C112.295 124.78 119.801 122.68 118.93 116.656C118.06 110.632 108.31 114.851 105.734 115.598",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M101.815 95.5164C99.8402 96.2394 98.2998 110.288 99.3288 110.46C100.358 110.631 110.684 107.33 110.99 106.51C111.296 105.689 104.226 94.6332 101.815 95.5164",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M98.5 75.0117C98.559 75.0117 98.559 74.9207 98.5 74.9207C98.441 74.9207 98.441 75.0117 98.5 75.0117",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A2BD",
    fillRule: "evenodd",
    d: "M77.0325 62.2701C75.9568 60.7172 73.4266 60.0802 71.5779 60.702C68.6596 61.6844 67.266 64.6341 68.386 67.2563C69.1058 68.9419 70.367 70.6192 72.665 70.455C74.0587 70.357 75.626 69.4016 76.546 68.4762C78.3375 66.6758 78.4423 64.3057 77.0325 62.2701",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A2BD",
    fillRule: "evenodd",
    d: "M56.2521 65.5051C53.3836 65.2068 50.5194 66.6442 50.0748 69.0656C49.4925 72.24 52.3843 74.9093 56.1689 75.4084C59.5672 75.8552 62.101 73.6485 61.9969 71.0073C61.8939 68.4133 59.5676 65.85 56.2521 65.5051",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A2BD",
    fillRule: "evenodd",
    d: "M58.0957 58.8659C58.9696 59.5373 60.3316 59.6675 61.3041 59.1447C62.5676 58.4655 63.561 57.1834 63.9429 55.7856C64.2873 53.294 63.0299 51.3209 61.3364 50.7286C60.1364 50.2626 58.8179 50.3919 57.6303 51.3209C55.0739 53.3227 55.7497 57.0638 58.0957 58.8659Z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    fillRule: "evenodd",
    d: "M61 125.221C72.141 135.404 88.9449 141.332 112.385 137.068C124.208 134.283 128.022 125.309 129 116.466C121.521 127.538 115.753 130.917 100.361 132.228C81.7938 133.812 73.4248 129.091 61 125.221",
    clipRule: "evenodd",
    opacity: 0.01
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultUser);
export default __webpack_public_path__ + "static/media/result_user.c6bc422111d4f61cf51745b077bed8a3.svg";
export { ForwardRef as ReactComponent };